/**
 * Helper utilities for resident vehicles (cars & bikes)
 */

export function parseVehicles(val) {
    if (!val) return [];
    if (Array.isArray(val)) {
        return val
            .filter((item) => item && (typeof item === "string" ? item.trim() : item.number))
            .map((item) => {
                if (typeof item === "string") {
                    const isBike = /bike|scooter|two-wheeler/i.test(item);
                    const clean = item.replace(/\s*\((car|bike|two-wheeler)\)/gi, "").trim();
                    return { type: isBike ? "bike" : "car", number: clean || item.trim() };
                }
                const vtype = (item.type || "car").toLowerCase() === "bike" ? "bike" : "car";
                return { type: vtype, number: (item.number || "").trim() };
            });
    }

    if (typeof val === "string") {
        return val
            .split(/[,;\n]+/)
            .map((chunk) => chunk.trim())
            .filter(Boolean)
            .map((chunk) => {
                const isBike = /bike|scooter|two-wheeler/i.test(chunk);
                const clean = chunk.replace(/\s*\((car|bike|two-wheeler)\)/gi, "").trim();
                return { type: isBike ? "bike" : "car", number: clean || chunk };
            });
    }

    return [];
}

export function formatVehiclesForPayload(vehiclesList) {
    if (!Array.isArray(vehiclesList)) return [];
    return vehiclesList
        .filter((v) => v && v.number && v.number.trim())
        .map((v) => ({
            type: v.type === "bike" ? "bike" : "car",
            number: v.number.trim().toUpperCase(),
        }));
}

export function vehicleSearchString(val) {
    const list = parseVehicles(val);
    if (!list.length) return "";
    return list.map((v) => `${v.type} ${v.number}`).join(" ");
}
